exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workflow-import-mapper-table-collapse .ant-collapse-item {\n  border: 0;\n}\n.workflow-import-mapper-table .ant-form-item {\n  margin: 0;\n}\n", ""]);

// exports
